import React from "react";
import {
  Paperclip,
  CreditCard,
  FileEarmarkText,
  FileEarmark,
  PencilSquare,
  FileExcelFill,
  FileEarmarkXFill,
} from "react-bootstrap-icons";

const TYPE_META = {
  "New Preneed Contracts": { Icon: FileEarmarkText, color: "#2B6CB0" },
  "Batch Payments": { Icon: CreditCard, color: "#276749" },
  "Batch Distribution Request": {
    Icon: FileExcelFill,
    color: "#168b2a",
  },
  "Contract Cancellation Request": { Icon: FileEarmarkXFill, color: "#e93c07" },
  "Contract Update/Change": { Icon: PencilSquare, color: "#553C9A" },
  "File Cabinet": { Icon: Paperclip, color: "#2B6CB0" },
};

const TYPE_BADGES = {
  "File Cabinet": { badge: "Multi-contract", badgeColor: "#2B6CB0" },
  Compliance: { badge: "Required", badgeColor: "#C05621" },
};

const FALLBACK = { Icon: FileEarmark, color: "#718096" };

export function getTypeMeta(id) {
  return TYPE_META[id] || FALLBACK;
}

export function getTypeBadge(name) {
  return TYPE_BADGES[name] || null;
}

const UploadTypeIcon = (props) => {
  const name = props.name;
  const size = props.size || 16;
  const meta = getTypeMeta(name);
  const color = props.color !== undefined ? props.color : "#fff";
  return React.createElement(meta.Icon, { size: size, color: color });
};

export default UploadTypeIcon;
